import gql from 'graphql-tag'

const statisticShopFragment = gql`
	fragment CustomerStatisticShopFragment on StatisticShop {
		shopId
		total
		closingData(includeCashbook: true) {
			cashDifference
		}
		totalPerBill
		customerCount: number
		realHours
		totalPerRealTimeHours
	}
`

const query = gql`
	query getShopStatisticsData($requestId: ID!) {
		cashAssist {
			getStatisticsData(requestId: $requestId) {
				status
				progress
				data{
					...CustomerStatisticShopFragment
				}
			}
		}
	}
${statisticShopFragment}
`

export default query
